<template>
    <div style="display: inline-block;width: 100%;flex-direction: column;background: #1a1e21;">
        <!-- <nav class="navbar navbar-expand-lg p-0">
                <div class="collapse navbar-collapse">
                    <div class="navbar-nav w-100 top-nav-bar">
                        <a class="nav-item nav-link" style="width:16%;font-size: 24px !important" v-on:click="tabType = 'Metadata';" :class='{active: tabType === "Metadata"}'>Metadata
                            <span class="sr-only">(current)</span>
                        </a>
                    </div>
                </div>
        </nav> -->
        <div style="display: inline-block;justify-content: end;width:100%;height:48px;">
            <div>
                <div class="config-value">
                    <div class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" style="width:100%;justify-content: end;padding-inline-end:10px">
                        <Multiselect
                            :value="'Status : '+selectedStatus.label"
                            :options="statusList"
                            :custom-label="customLabelPicklistSingleVal"
                            :searchable="true"
                            :close-on-select="true"
                            :ref="selectedStatus.label"
                            :allow-empty="false"
                            deselectLabel=""
                            track-by="type"
                            label="label"
                            selectLabel=""
                            selectedLabel=""
                            @select="onStatusChange($event)"
                            placeholder="Select status"
                            style="height: 41px !important; margin-top: 3px; margin-inline-end: 12px; min-width: 220px !important;width:auto;">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                            <DatePicker
                                range
                                placeholder="Requested on"
                                :value="timeBy"
                                valueType="format"
                                @change="filterSharedAssetsByDate($event)"
                                class="bg-transparent rounded  text-light"
                                style="height: 41px !important;margin-top: 3px; margin-inline-end: 12px;min-width: 220px !important;width:auto !important;"
                             >
                            </DatePicker>
                            <users-multiselect
                                v-show="isActionEnable('tag-metadata-approver') && panelTypeApprover"
                                ref="Requestedby"
                                :enableCheckbox="true"
                                :isSearchable="true"
                                privilegeCheck="tag-metadata-requestor"
                                customizePlaceholder="Requested by"
                                @selectedUserCompleteData='handleSharedToUsersList'
                                @removedUserCompleteData='handleShareToRemovedUserFromList'
                                :selectedUserIdList="('requestor_id' in filterBy)?filterBy.requestor_id:[]"
                                style="min-width: 220px !important;width:auto"
                                >
                            </users-multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:calc(100% - 50px);background: #1a1e21;display: flex;">
            <div v-if="sharedData.length !== 0" :class="showComments?'col-md-8 p-0':'col-md-12 p-0'">
                <div style="height:100%;overflow:auto">        
                    <ul v-for="shareD in getAssets()" :key="shareD._id"  class="thumbnail-view-ul common-view-ul"
                            :class="selectedRequestId==shareD._id?'activeclass':''"
                            @click="selectedRequestId=shareD._id;commentPage = 1;(showComments?loadComments(false):'')" @dblclick.prevent.stop="showAssetMetadataInfo(shareD._id)">
                            <li>
                                <div>
                                    <div style="display: flex">
                                        <div style="text-align: start;width: 5%;margin-inline-start: 12px;">
                                            <div @click="showAssetMetadataInfo(shareD._id)" class="comm-tag-title-hover"
                                             style="color:#e8912d;">{{shareD.m_req_id}}
                                            </div>
                                        </div>
                                        <div style="width:90%">
                                            <div style="width:98%">
                                                <div style="width:100%;display:inline-block;">
                                                    <div style="text-align: justify;width:205px;float:inline-start">
                                                        <div class="asset-thumbnail"
                                                            v-for="(file, index) in shareD.file_info" :key="file.asset_id"
                                                            :attr="file.asset_id"
                                                            @dblclick.prevent.stop="showAssetDetails(file)"
                                                            :class="{ activeAsset: isFileSelected(file) }"
                                                            :ripple="false"
                                                            data-app
                                                            style="position:relative"
                                                            :title="file.slug_name"
                                                            >
                                                                <div v-if="['catalog'].includes(file.asset_type)" class="thumbnail-view1">
                                                                    <div class="thumbnail-view"  v-if="('catalog_cover_photo_path' in file && file.catalog_cover_photo_path.trim().length > 0) ||
                                                                                ('catalog_type' in file && file.catalog_type == 'photo_album')" style="margin-bottom:13px;">
                                                                        <img  :src="getCatalogCoverPhoto(file)" @error="replaceByDefaultImage" alt="image" draggable="false"/>
                                                                    </div>
                                                                    <div v-else-if="'catalog_cover_photo_file_uid' in file && file.catalog_cover_photo_file_uid.trim().length > 0 && file.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 40px;width: 40px;margin: auto 33px 23px;float:inline-start" v-html="getSvgIconForCoverPhoto(file.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
                                                                    <svg  v-else xmlns="http://www.w3.org/2000/svg" width="80px" height="91px" fill="#5f777d" viewBox="0 0 16 16" class="bi bi-folder-fill">
                                                                        <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z">
                                                                        </path>
                                                                        <title>{{file.catalog_name}}</title>
                                                                    </svg>
                                                                    <div class="file-name" style="top: -11px !important;" :title="file.catalog_name" v-if="!getHighlightFilename(file,file.catalog_name).highlight">
                                                                        <div v-if="('catalog_type' in file && file.catalog_type == 'photo_album')" style="display:inline-table;position:relative;height:20px;width:20px;" >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3m-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981z"/>
                                                                            </svg>
                                                                            <svg data-v-0f3c7d65="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="bi bi-card-image" style="height: 18px;width: 11px;inset-inline-end :4px;position: absolute;border-radius: 10px;background: transparent;top: 4px;fill: #1a1e21;">
                                                                                <path data-v-0f3c7d65="" d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"></path><path data-v-0f3c7d65="" d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5z">
                                                                                </path>
                                                                            </svg>
                                                                        </div>
                                                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3m-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981z"/>
                                                                        </svg>
                                                                        {{ file.catalog_name }}
                                                                    </div>
                                                                    <div class="storage-type-icons-wrapper" :style="('catalog_type' in file && file.catalog_type == 'photo_album')?'':'inset-inline-end :60px; !important'">
                                                                            <div class="overflow-parent-div">
                                                                                <svg @click="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                                                    <title>{{$t('More actions')}}</title>
                                                                                    <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                                                </svg>
                                                                                <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                                                        <div v-if='("asset_id" in file)' class="action-div" @click="openAssetInCatalog(file)" title="Open in catalog">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                                                            </svg>
                                                                                        {{$t('Open in catalog')}}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                </div>
                                                                <template v-else>
                                                                    <div v-if="index == 0" class="thumbnail-view" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false" >
                                                                        <img  :src="getThumbnailPath(file)" @error="replaceByDefaultImage" alt="image" draggable="false"/>
                                                                        <div v-if="file.state && file.state == 'OUTDATED'" class="outdated-text">
                                                                            OUTDATED
                                                                        </div>
                                                                        <div class="storage-type-icons-wrapper">
                                                                            <svg v-if="isActionEnable('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                                                <title>Download</title>
                                                                                <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                                                <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                            </svg>
                                                                            <svg v-if="isActionEnable('Share')" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-share-fill" viewBox="0 0 16 16">
                                                                                <title>{{$t('Share')}}</title>
                                                                                <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                                                            </svg>
                                                                            <svg @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                                                                <title>{{$t('Preview')}}</title>
                                                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                                                            </svg>
                                                                            <div class="overflow-parent-div">
                                                                                <svg @click="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                                                    <title>{{$t('More actions')}}</title>
                                                                                    <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                                                </svg>
                                                                                <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                                                        <div class="action-div" @click="setClipBoardText(file)" title="Copy link">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                                                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                                                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                                                            </svg>
                                                                                        {{$t('Copy link')}}
                                                                                        </div>
                                                                                        <div v-if='("asset_id" in file)' class="action-div" @click="openAssetInCatalog(file)" title="Open in catalog">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                                                            </svg>
                                                                                            {{$t('Open in catalog')}}
                                                                                        </div>
                                                                                        <div v-if="file.state && file.state == 'OUTDATED' && getVersionInfoDisplayCheck" class="action-div" @click="openManageVersions(file)" title="View versions">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-files" viewBox="0 0 16 16">
                                                                                                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                                                            </svg>
                                                                                            View versions
                                                                                        </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="thumbnail-data d-inline-flex">
                                                                        <div
                                                                            v-html="getSvgIconsOfMediaTypes(file)" 
                                                                            class="svg-icons-display"
                                                                        ></div>
                                                                        <div class="file-name" :title="file.slug_name" v-if="!getHighlightFilename(file,file.slug_name).highlight">
                                                                            {{ file.slug_name }}
                                                                        </div>
                                                                        <div class="file-name" :title="file.slug_name" v-else v-html="getHighlightFilename(file,file.slug_name).slugname">
                                                                        </div>
                                                                    </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div style="width:calc(100% - 205px);display:inline-block;">
                                                        <div class="value-ellipsis-to-entry" style="inset-inline-start:12px;">
                                                            <div style="display:inline-block;float:inline-start">
                                                                <div v-if=" Object.keys(shareD).includes('requestor_profile_image') &&
                                                                    ![undefined,null].includes(shareD.requestor_profile_image) &&
                                                                    shareD.requestor_profile_image"
                                                                    :title="shareD.requestor_name"
                                                                    class='user-name-or-image'>
                                                                        <img :src="getProxyConvertedURL(shareD.requestor_profile_image)" @error="replaceWithUserIcon($event,shareD.requestor_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                                </div>
                                                                <div v-else-if="shareD.requestor_name != undefined && shareD.requestor_name.length > 0"
                                                                    class="user-name-or-image user-name" :style="style(shareD.requestor_name)"
                                                                    :title="shareD.requestor_name">
                                                                    {{ shareD.requestor_name.split("")[0] }}
                                                                </div>
                                                            </div>
                                                            <div class="text-left" style="padding: 1px 0px 0px 10px;flex-wrap: wrap;margin-top: 0px;width:calc(100% - 40px);float:inline-start;">
                                                                <div style="margin-inline-end: 3px;float:inline-start"> {{shareD.requestor_name}} requested</div>
                                                                <!-- <div class="comm-tag-title-hover" @click="showAssetMetadataInfo(shareD._id)" style="color:#e8912d; margin-inline-end: 3px;float:inline-start">{{shareD.m_req_id}}</div> -->
                                                                <div style="margin-inline-start: 2px;float:inline-start;margin-inline-end: 2px">for </div>
                                                                <div class="comm-tag-title-hover" @click="showAssetDetails(shareD.file_info[0])" style="float:inline-start;margin-inline-start: 2px;color: #1d9bd1"
                                                                :title="getAllSharedFilesToolTip(shareD.file_info)"> {{shareD.file_info[0].slug_name}} </div>
                                                                <div style="float:inline-start">
                                                                    <span v-if="'asset_type' in shareD.file_info[0] && ['catalog'].includes(shareD.file_info[0].asset_type)" style="margin-inline-start: 2px;">{{$t('catalog')}}</span>
                                                                    <span v-else style="margin-inline-start: 4px;"> {{$t('file')}}</span>
                                                                </div>
                                                                <div style="margin-inline-start: 4px;float:inline-start"> fields update </div>
                                                                <div class='dull-text-display metadata-status' style="margin-inline-start: 15px;float:inline-start">
                                                                       {{getDateAndTimeInConfiguredFormat(shareD.created_date)}}
                                                                        <span v-if="Object.keys(shareD).includes('status') && shareD.status.length > 0"
                                                                                    :title="shareD.approver_id!=null?shareD.status + ' by ' + shareD.approver_name:shareD.status"
                                                                                    class="status-as-tag"
                                                                            :class="shareD.status=='approved'?'status-approved':(shareD.status == 'rejected'?'status-rejected':'status-open')">
                                                                            <svg v-show="shareD.status != 'open'" class="svg-icon" fill="currentColor" v-html="getStatusIcon(shareD.status)">
                                                                            </svg>
                                                                            {{shareD.status}}
                                                                        </span>
                                                                </div>
                                                                    <!-- <div style="width:20%;display: inline-block;position: relative;bottom: 5px;margin-inline-start:10px;float:inline-end;text-align:end">
                                                                        <span v-if="Object.keys(shareD).includes('status') && shareD.status.length > 0"
                                                                                    :title="shareD.approver_id!=null?shareD.status + ' by ' + shareD.approver_name:shareD.status"
                                                                                    style="font-size: 16px;width:100%;text-transform:capitalize;">
                                                                            <svg v-show="shareD.status != 'open'" class="svg-icon" fill="currentColor" v-html="getStatusIcon(shareD.status)">
                                                                            </svg>
                                                                            <span v-if="shareD.status == 'open'">{{shareD.status}}</span>
                                                                        </span>
                                                                    </div> -->
                                                            </div>
                                                        </div>
                                                        <div v-for="op of shareD.comments"  class="value-ellipsis-to-entry"
                                                            style="color: rgb(173, 173, 173);text-align: start;padding: 1px 0px 0px 10px;display: flex;"
                                                            :title="getCommentTooltipD(op)" :key="op._id"
                                                            @click.prevent.stop="selectedRequestId=shareD._id;switchToComment()">
                                                            <div v-if=" Object.keys(op).includes('requestor_profile_image') &&
                                                                        ![undefined,null].includes(op.requestor_profile_image) &&
                                                                        op.requestor_profile_image"
                                                                        :title="op.requestor_name"
                                                                        class='user-name-or-image'>
                                                                <img :src="getProxyConvertedURL(op.requestor_profile_image)" @error="replaceWithUserIcon($event,op.requestor_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                            </div>
                                                            <div v-else-if="op.requestor_name != undefined && op.requestor_name.length > 0"
                                                                class="user-name-or-image user-name" :style="style(op.requestor_name)" :title="op.requestor_name">
                                                                {{ op.requestor_name.split("")[0] }}
                                                            </div>
                                                            <div class="col-11" style="margin-inline-start: 6px;width:98%;text-align: start; padding: 0px !important;">
                                                                <div style="display:flex;">
                                                                    <!-- <i>Commented by </i>  -->
                                                                    <span style="margin-inline-start: 5px;color:#dde4e4">{{op.requestor_name}} commented.</span>
                                                                    <div class="commented-date" style="position:relative;inset-inline-start:8px;top:4px;font-size:11px">
                                                                        {{getDateAndTimeInConfiguredFormat(op.created_datetime)}}
                                                                    </div>
                                                                    <div v-if="shareD.comments_count >= 1" class="comm-tag-title-hover" style="color:#007bff; margin-inline-end: 3px;margin-inline-start: 18px;float:inline-start"
                                                                        @click.prevent.stop="selectedRequestId=shareD._id;switchToComment()">
                                                                        + {{shareD.comments_count}} More
                                                                    </div>
                                                                </div>
                                                                <div v-if="op.status != 'Deleted'" style="margin-inline-start: 5px">
                                                                    <div class="comment-ellipsis-to-entry comment-data-div comment-text-cursor">
                                                                        {{op.comment}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="shareD.approver_id != null" class="value-ellipsis-to-entry"
                                                            style="text-align: start;padding: 1px 0px 0px 10px;display: flex;">
                                                            <div v-if=" Object.keys(shareD).includes('approver_profile_image') &&
                                                                        ![undefined,null].includes(shareD.approver_profile_image) &&
                                                                        shareD.approver_profile_image"
                                                                        :title="shareD.approver_name"
                                                                        class='user-name-or-image'>
                                                                <img :src="getProxyConvertedURL(shareD.approver_profile_image)" @error="replaceWithUserIcon($event,shareD.approver_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                            </div>
                                                            <div v-else-if="shareD.approver_name != undefined && shareD.approver_name.length > 0"
                                                                class="user-name-or-image user-name" :style="style(shareD.approver_name)" :title="shareD.approver_name">
                                                                {{ shareD.approver_name.split("")[0] }}
                                                            </div>
                                                            <div class="col-11" style="margin-inline-start: 10px;width:98%;text-align: start; padding: 0px !important;display:flex">
                                                                <div style="float:inline-start">{{shareD.approver_name}}</div> 
                                                                <div v-if="shareD.status == 'approved'" style="color:#05d105;text-transform: capitalize;margin-inline-start:5px;display:inline-block">{{shareD.status}}</div>
                                                                <div v-else-if="shareD.status == 'rejected'" style="color:#fb6262;text-transform: capitalize;margin-inline-start:5px;display:inline-block">{{shareD.status}}</div>    
                                                                <div v-else style="text-transform: capitalize;margin-inline-start:5px;display:inline-block">{{shareD.status}}</div>
                                                                <div style="margin-inline-start: 5px;"> the request.</div>
                                                            </div>
                                                        </div>
                                                        <div class="text-left" style="background: #22272b;margin-inline-start: 56px;border-inline-start: 3px solid rgba(245,157,0,.8117647058823529);padding: 1px 90px 0px 10px;display:inline-block;width:95%">
                                                            <div v-for="(field,index) of shareD.metadata_request" :key="field.key_id" style="display: inline-block;width:100%;margin-inline-end: 1px;margin-inline-start: 1px;float:inline-start">
                                                                <template v-if="index < 5">
                                                                    <div style="color: #858585" class="metadata-key-styles">
                                                                        <span v-if="['slug_name'].includes(field.key_id)" class="key-ellipsis-to-entry" :title="field.key_id" style="text-transform:capitalize;">{{$t('Media slug')}}</span>
                                                                        <!-- <span v-if="['description','tag','catalog'].includes(field.key_id)" class="key-ellipsis-to-entry" :title="field.key_id" style="text-transform:capitalize;">{{field.key_id}}</span>
                                                                        <span v-if="['tag'].includes(field.key_id) && field.tag_info.length > 1" :title="field.key_id">s</span>
                                                                        <span v-if="['catalog'].includes(field.key_id) && field.catalog_info.length > 1" :title="field.key_id">s</span> -->
                                                                        <span v-if="['description'].includes(field.key_id)" class="key-ellipsis-to-entry" :title="field.key_id" style="text-transform:capitalize;">{{field.key_id}}</span>
                                                                        <span v-if="['tag'].includes(field.key_id)" :title="field.key_id">{{field.key_id}}
                                                                            <template v-if="field.tag_info.length > 1"></template>s</span>
                                                                        <span v-if="['catalog'].includes(field.key_id) && field.catalog_info.length > 1" :title="field.key_id">{{field.key_id}}s</span>
                                                                        <span v-if="['catalog'].includes(field.key_id) && field.catalog_info.length == 1" :title="field.key_id">{{field.key_id}}</span>
                                                                        <span v-if="!['description','slug_name','tag','catalog'].includes(field.key_id)" class="key-ellipsis-to-entry" :title="getFieldKeyName(field.key_id)" style="text-transform:capitalize;">{{getFieldKeyName(field.key_id)}}</span>
                                                                    </div>
                                                                    <div style="float:inline-start;margin-inline-start:6px;display:inline-block:width:5px"> : </div>
                                                                    <div class="metadata-value-styles">
                                                                        <span v-if="['description','slug_name'].includes(field.key_id)" class="value-ellipsis-to-entry" style="float: inline-start;max-width:100%" :title="field.value">
                                                                            <template v-if="field.value">{{field.value}}</template>
                                                                            <template v-else>None</template>
                                                                        </span>
                                                                        <span v-else-if="['tag'].includes(field.key_id)" class="value-ellipsis-to-entry" style="float: inline-start;max-width:100%" :title="getTagsNameList(field.tag_info)">{{getTagsNameList(field.tag_info)}}</span>
                                                                        <span v-else-if="['catalog'].includes(field.key_id)" class="value-ellipsis-to-entry" style="float: inline-start;max-width:100%" :title="getCatalogsNameList(field.catalog_info)">{{getCatalogsNameList(field.catalog_info)}}</span>
                                                                        <span v-else-if="['PICKLIST','PICKLIST_MULTIVALUE'].includes(field.metadta_type)" class="value-ellipsis-to-entry" style="float: inline-start;max-width:100%" :title="getPiclistNameList(field.field_info)">{{getPiclistNameList(field.field_info)}}</span>
                                                                        <span v-else :title='field.value.join(",")' class="value-ellipsis-to-entry" style="float: inline-start;max-width:100%">
                                                                            <template v-if='field.value && field.value.length > 0'>{{field.value.join(",")}}</template>
                                                                            <template v-else>None</template>
                                                                        </span>
                                                                        <div v-if="(index == 4) && shareD.metadata_request.length > 5" class="comm-tag-title-hover"
                                                                             style="display:inline-block;color:#007bff; margin-inline-end: 3px;margin-inline-start: 18px;"
                                                                                        @click.prevent.stop="showAssetMetadataInfo(shareD._id)">
                                                                                        + {{shareD.metadata_request.length - 5}} More
                                                                        </div>
                                                                    </div>
                                                                    <!-- <span v-if="(idx + 1) < shareD.metadata_request.length"  style="margin-inline-end: 3px;">  ,  </span> -->
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>    
                                                </div>   
                                                <div style="text-align: justify;width:205px;float:inline-start">
                                                        <div class="asset-thumbnail"
                                                            v-for="file in shareD.file_info.slice(1)" :key="file.asset_id"
                                                            :attr="file.asset_id"
                                                            @dblclick.prevent.stop="showAssetDetails(file)"
                                                            :class="{ activeAsset: isFileSelected(file) }"
                                                            :ripple="false"
                                                            data-app
                                                            style="position:relative"
                                                            :title="file.slug_name"
                                                            >
                                                            <div class="thumbnail-view" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false"
                                                                :class="'state' in file && file.state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                                                <img :src="getThumbnailPath(file)" @error="replaceByDefaultImage" alt="image" draggable="false"/>
                                                                <div v-if="file.state && file.state == 'OUTDATED'" class="outdated-text">
                                                                    OUTDATED
                                                                </div>
                                                                <div class="storage-type-icons-wrapper">
                                                                    <template v-if="(!('state' in file) || ('state' in file && !['MARK FOR DELETE'].includes(file.state)))">
                                                                        <svg v-if="isActionEnable('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                                            <title>{{$t('Download')}}</title>
                                                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                                        </svg>
                                                                        <svg v-if="isActionEnable('Share')" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-share-fill" viewBox="0 0 16 16">
                                                                            <title>{{$t('Share')}}</title>
                                                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                                                        </svg>
                                                                    </template>
                                                                    <svg @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                                                        <title>{{$t('Preview')}}</title>
                                                                        <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                                                    </svg>
                                                                    <div class="overflow-parent-div">
                                                                    <svg @click="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                                        <title>More actions</title>
                                                                        <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                                    </svg>
                                                                    <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                                            <div class="action-div" @click="setClipBoardText(file)" title="Copy link">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                                                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                                                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                                                </svg>
                                                                            {{$t('Copy link')}}
                                                                            </div>
                                                                            <div v-if='("asset_id" in file)' class="action-div" @click="openAssetInCatalog(file)" title="Open in catalog">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                                                </svg>
                                                                            {{$t('Open in catalog')}}
                                                                            </div>
                                                                            <div v-if="file.state && file.state == 'OUTDATED' && getVersionInfoDisplayCheck" @click="openManageVersions(file)" class="action-div">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-files" viewBox="0 0 16 16">
                                                                                    <title>{{$t('View versions')}}</title>
                                                                                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                                                </svg>
                                                                                {{$t('View versions')}}
                                                                            </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="thumbnail-data d-inline-flex">
                                                                <div
                                                                    v-html="getSvgIconsOfMediaTypes(file)" 
                                                                    class="svg-icons-display"
                                                                ></div>
                                                                <div class="file-name" :title="file.slug_name" v-if="!getHighlightFilename(file,file.slug_name).highlight">
                                                                    {{ file.slug_name }}
                                                                </div>
                                                                <div class="file-name" :title="file.slug_name" v-else v-html="getHighlightFilename(file,file.slug_name).slugname">
                                                                </div>
                                                            </div>
                                                            <template v-if="'state' in file">
                                                                <div v-if="file.state != 'READY' && file.state != 'MARK FOR DELETE'">
                                                                    <img
                                                                    :src="growingFileGif"
                                                                    alt="loading"
                                                                    style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                                                                    />
                                                                </div>
                                                                <div v-else-if="file.state == 'MARK FOR DELETE'">
                                                                    <img
                                                                    :src="markForDeleteIcn"
                                                                    alt="markfordelete"
                                                                    style="height:20px;width:20px;position:absolute;bottom:55%;inset-inline-start:42%"
                                                                    />
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div v-if="shareD.file_info.length <= 0">
                                                            <div class="asset-thumbnail"
                                                                v-for="fileId in shareD.asset_ids" :key="fileId"
                                                                :attr="fileId"
                                                                :ripple="false"
                                                                data-app
                                                                style="position:relative"
                                                                title="Requested Asset is not available for preview."
                                                                >
                                                                <div class="thumbnail-view reduce-opacity" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false">
                                                                    <img :src="getThumbnailPath({})"  @error="replaceByDefaultImage" alt="image" draggable="false"/>
                                                                </div>
                                                                <img
                                                                    :src="markForDeleteIcn"
                                                                    alt="markfordelete"
                                                                    style="height:20px;width:20px;position:absolute;bottom:55%;inset-inline-start:42%"
                                                                />
                                                            </div>
                                                        </div>
                                                </div> 
                                            </div>
                                        </div>    
                                    </div>
                                        <!-- <div style="padding-inline-start: 31px;text-align: justify;">
                                            <div class="asset-thumbnail"
                                                v-for="file in shareD.file_info" :key="file.asset_id"
                                                :attr="file.asset_id"
                                                @dblclick.prevent.stop="showAssetDetails(file)"
                                                :class="{ activeAsset: isFileSelected(file) }"
                                                :ripple="false"
                                                data-app
                                                style="position:relative"
                                                :title="file.slug_name"
                                                >
                                                <div class="thumbnail-view" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false" >
                                                    <img :src="getThumbnailPath(file)" alt="image" draggable="false"/>
                                                    <div class="storage-type-icons-wrapper">
                                                        <svg v-if="isActionEnable('Download')" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                            <title>Download</title>
                                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                        </svg>
                                                        <svg v-if="isActionEnable('Share')" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-share-fill" viewBox="0 0 16 16">
                                                            <title>Share</title>
                                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                                        </svg>
                                                        <svg @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                                            <title>Preview</title>
                                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                                        </svg>
                                                        <div class="overflow-parent-div">
                                                        <svg @click="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                            <title>More actions</title>
                                                            <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                        </svg>
                                                        <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                                <div class="action-div" @click="setClipBoardText(file)" title="Copy link">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                                        <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                                        <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                                    </svg>
                                                                Copy link
                                                                </div>
                                                                <div v-if='("asset_id" in file)' class="action-div" @click="openAssetInCatalog(file)" title="Open in catalog">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                                                        <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                                                    </svg>
                                                                Open in catalog</div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="thumbnail-data d-inline-flex">
                                                    <div
                                                        v-html="getSvgIconsOfMediaTypes(file)" 
                                                        class="svg-icons-display"
                                                    ></div>
                                                    <div class="file-name" :title="file.slug_name" v-if="!getHighlightFilename(file,file.slug_name).highlight">
                                                        {{ file.slug_name }}
                                                    </div>
                                                    <div class="file-name" :title="file.slug_name" v-else v-html="getHighlightFilename(file,file.slug_name).slugname">
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                </div>
                                <div class="parent-comment-options-wrapper" style="border: 1px solid #444444;">
                                        <button  class="btn p-1 m-1 pr-2 default-buttons" :title="$t('Add comment')"
                                                style="color: #a3adad !important;border: 1px solid #a3adad!important;width: 99px;!important"
                                                @click.prevent.stop="selectedRequestId=shareD._id;switchToComment()" >
                                            <svg xmlns="http://www.w3.org/2000/svg" style="margin-inline-end: 2px;" width="20" height="20" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
                                                        <title>{{$t('Add comment')}}</title>
                                                        <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                        <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"/>
                                            </svg>{{$t('Comment')}}
                                        </button>
                                    <button  class="btn p-1 m-1 pr-2 default-buttons" :title='$t("View request details")'
                                                style="color: #a3adad !important;border: 1px solid #a3adad!important;width: 75px;!important"
                                                @click.prevent.stop="showAssetMetadataInfo(shareD._id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="float: inline-start;" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                                <title>{{$t('View request details')}}</title>
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                            </svg>{{$t('View')}}
                                    </button>
                                    <template v-if="shareD.status=='open' && shareD.requestor_id == getLoggedInUserId && isActionEnable('tag-metadata-requestor') && !panelTypeApprover">
                                        <button class="btn p-1 m-1 pr-2 default-buttons" title="Update"
                                                style="color: #a3adad !important;border: 1px solid #a3adad!important;width: 92px;!important"
                                                @click.prevent.stop="selectedRequestId=shareD._id;reRequest(shareD.metadata_request, shareD.file_info[0], true)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                            </svg>{{$t('Edit')}}
                                        </button>
                                    </template>
                                    <template v-if="shareD.status=='rejected' && shareD.requestor_id == getLoggedInUserId && isActionEnable('tag-metadata-requestor') && !panelTypeApprover">
                                        <button class="btn p-1 m-1 pr-2 default-buttons" title="Update"
                                                style="color: #a3adad !important;border: 1px solid #a3adad!important;width: 102px;!important"
                                                @click.prevent.stop="selectedRequestId=shareD._id;reRequest(shareD.metadata_request, shareD.file_info[0], false)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                            </svg>{{$t('Re request')}}
                                        </button>
                                    </template>
                                    <template v-if="shareD.status=='open' && isActionEnable('tag-metadata-approver') && panelTypeApprover">
                                        <button  class="btn btn-outline-danger p-1 m-1 pr-2" title="Reject"
                                                @click.prevent.stop="selectedRequestId=shareD._id;reject()">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                                                <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                                            </svg>{{$t('Reject')}}
                                        </button>
                                        <button class="btn btn-outline-primary p-1 m-1" title="Approve" @click.prevent.stop="selectedRequestId=shareD._id;updateRequestStatus('approved')" >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                                            </svg>{{$t('Approve')}}
                                        </button>
                                    </template>
                                        <!-- <div class="comment-overflow-parent-div">
                                            <svg @click="cEOMenu=!cEOMenu" width="22" height="22" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                                <title>More actions</title>
                                                <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                            </svg>
                                            <div v-if="cEOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                                <div class="action-div" @click.prevent.stop="selectedRequestId=shareD._id;switchToComment()" title="Add comment">
                                                    <svg xmlns="http://www.w3.org/2000/svg" style="margin-inline-end: 7px;" width="20" height="20" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
                                                        <title>Add comment</title>
                                                        <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                        <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"/>
                                                    </svg>{{$t('Add comment')}}
                                                </div>
                                            </div>
                                        </div> -->
                                </div>
                            </li>
                    </ul>
                    <ul class="comments-dock">
                        <li v-on:click="loadComments(false)">
                            <svg title="View comments" @click="showComments=!showComments" xmlns="http://www.w3.org/2000/svg" width="20" height="20"  fill="currentColor" v-if="!showComments" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                            </svg>
                            <svg title="Close comments" @click="showComments=!showComments" xmlns="http://www.w3.org/2000/svg" width="20" height="20" v-if="showComments"  fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                            </svg>
                        </li>
                    </ul>
                </div>    
            </div>
            <div v-else style="width:100%">
                <div style="font-size: 45px; margin: 15%; color: #686868">
                    {{$t('No Requests Found')}}
                </div>
            </div>
            <div v-show="showComments" class="col-md-4 p-0" ref="commentsDockWidget" style="background: #1a1e21;border-inline-start: 1px solid #2b2b2b;">
                <div class="comment-thread-wrapper" style="position:relative;height:100%;">
                    <div class="close-or-min-panel">
                        <div class="heading" style="width:calc(100% - 40px)">{{$t('Comments')}}</div>
                        <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="showComments=false" style="width:40px;" :title="$t('Close comments')">
                            <span aria-hidden="true">
                                <cancel-icon class="close-icon" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="comments-section">
                        <div v-on:scroll="loadMoreComments($event)" ref='commentThreadWindow' class="added-comments-wrapper" id="media_window_wrapper" :style="{'max-height': 'calc(100% - 160px)'}">  <!--:style="{'max-height':resizedHeight - 50}" --> 
                                <div  v-for="op in commentsList" :key="op._id" class="comm-comment-wrapper w-100 d-flex">
                                    <div v-if=" Object.keys(op).includes('requestor_profile_image') &&
                                                ![undefined,null].includes(op.requestor_profile_image) &&
                                                op.requestor_profile_image"
                                                :title="op.requestor_name"
                                                class='user-name-or-image'>
                                        <img :src="getProxyConvertedURL(op.requestor_profile_image)" @error="replaceWithUserIcon($event,op.requestor_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                    </div>
                                    <div v-else-if="op.requestor_name != undefined && op.requestor_name.length > 0"
                                        class="user-name-or-image user-name" :style="style(op.requestor_name)"
                                        :title="op.requestor_name">
                                        {{ op.requestor_name.split("")[0] }}
                                    </div>
                                    <div class="col-11" style="margin-inline-start: 6px;width:98%;text-align: start; padding: 0px !important;">
                                        <div style="display:flex;">
                                            {{op.requestor_name}}
                                            <div class="commented-date" style="position:relative;inset-inline-start:8px;top:4px;font-size:11px">
                                                {{getDateAndTimeInConfiguredFormat(op.created_datetime)}}
                                            </div>
                                        </div>
                                        <div v-if="op.status != 'Deleted'">
                                            <div v-if="selectedCommentId == op._id" class="common-input-field">
                                                <textarea type="text" ref="commentTextField"
                                                        class="bg-transparent border rounded text-light form-control input-fields"
                                                        style="padding-inline-start: 5px;padding-top: 2px;margin: 0px;max-height: 200px;min-height: 80px;" v-model="editedCommentText">
                                                </textarea>
                                                <div class="modal-footer p-0 primary-btn-style">
                                                    <button @click="cancelEditModeofSelectedComment()" class="btn btn-outline-secondary" :title="$t('Cancel edited comment')"
                                                     style="line-height: initial;margin-inline-end:10px;">Cancel
                                                    </button>
                                                    <button class="btn btn-outline-primary ml-1" @click="editSelectedComment(op._id)" title="Save comment"
                                                         style="margin:0px !important">{{$t('Save')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div v-else class="comment-data-div comment-text-cursor">{{op.comment}}
                                                <i v-if="'edited_on' in op && op.edited_on.length > 0" style="color: #8b8b8b;display: flex;justify-content: flex-start;">{{$t('edited')}}</i>
                                            </div>
                                        </div>
                                        <div v-else style="color: #8b8b8b;">
                                            <i>{{$t('This comment was deleted')}}</i>
                                        </div>
                                    </div>
                                    <div v-if="op.status != 'Deleted'" class="actions-on-messages">
                                        <!-- <svg v-on:click="replyThreadRoute(message)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-reply-fill" viewBox="0 0 16 16">
                                            <path d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/>
                                            <title>Reply</title>
                                        </svg> -->
                                        <svg v-if="op.user_id == getLoggedInUserId" v-on:click="editedCommentText=op.comment;enableEditModeofComment(op._id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                                            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                            <title>{{$t('Edit comment')}}</title>
                                        </svg>
                                        <svg v-if="op.user_id == getLoggedInUserId" v-on:click="deleteSelectedCommnet(op._id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                            <title>{{$t('Delete comment')}}</title>
                                        </svg>
                                    </div>
                                </div>
                        </div>
                        <div class="common-input-field">
                            <textarea type="text" ref="commentTextField"
                                    class="bg-transparent border rounded text-light form-control input-fields"
                                    style="padding-inline-start: 5px;padding-top: 2px;margin: 0px;max-height: 200px;min-height: 80px;" v-model="commentText">
                            </textarea>
                            <div class="modal-footer p-0 primary-btn-style">
                                <button class="btn btn-outline-primary ml-1" @click="addComment()" style="margin:0px !important">
                                    <svg data-v-bb966eee="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#eee" viewBox="0 0 16 16" class="bi bi-send-fill"><path data-v-bb966eee="" fill-rule="evenodd" d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"></path></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <pagination
                v-model="page"
                :records="totalAssets"
                :per-page="assetsPerpage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />
        </div>
        <requested-metadatainfo v-if="viewRequestedDetails" :requestId="selectedRequestId" @close="viewRequestedDetails=false"></requested-metadatainfo>
        <picture-in-picture v-if="openPip" :selectedFile="assetDetailsToShowPip" @maximisePlayer="showAssetDetailsDockCloseMaximisedplayer" @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
        <ImagePreviewDialog class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="assetDetailsToShowPip" @closeMiniPlayer="closeMinimisedPlayer" v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
        <OCBrowse v-if="enableOICBrowse" @close="closeOCBrowser()" @traverToCatalog="setRouterUrl" :pIPList="parentIPList"></OCBrowse>
        <RerequestMetadata v-if="reRequestComponent" :editInfo="editRequestInfo" :fileInfo="requestFileInfo" :requestedMetadata="requestedSequenceMetadata" @close="reRequestComponent=false;editRequestInfo=false"></RerequestMetadata>
        <router-view
            :name="getRouterName()"
            @close="closeModal">
        </router-view>
        <NewCommentComp v-if="openCommentComponent" @close="openCommentComponent=!openCommentComponent" @handleAddButtonClick="rejectWithComments"></NewCommentComp>
        <manage-version v-if="openVersionDisplayDialog" @close="closeVersionDisplayDialog" :fileInfo="selectedFileToViewVersions" :disableUpload='true'></manage-version>
    </div>
</template>    

<script>
import Utils from "../../components.utils.js";
import userMultiSelect from "../users/UserMultiselectField.vue";
import OpenCatalogBrowse from "../categories/OpenInCatalogBrowse.vue";
import { mapActions,mapGetters,mapMutations } from "vuex";
import highlightMixin from '../../mixins/highlightMixin.js';
import DatePicker from "vue2-datepicker";
import PictureInPicture from "../files/MiniPlayer.vue";
import ImagePreviewDialog from '../core/ImagePreviewDialog.vue';
import Constants from "../../components.constants.js";
import Pagination from "vue-pagination-2";
import {NotifierConstants} from "../../components.constants.js";
import RequestedAssetMetadataInfo from "./RequestedAssetMetadataInfo.vue"
import Multiselect from 'vue-multiselect'
import RerequestMetadata from "../files/MetadataRequestor.vue"
import cancelIcon from "../core/InlineCancelField.vue"
import NewCommentComp from "../actions/Comment.vue"
//import ManageVersionsDialog from "../ManageVersions/ManageVersionsDialog.vue";

export default {
    name: "mr",
    data(){
        return{
            tabType:'Metadata',
            commentPage:1,
            commentsPageCount:1,
            openCommentComponent:false,
            resizedHeight:"0",
            commnetresizedHeight:"calc(100% - 60px -38px)",
            commentsList:[],
            showComments:false,
            commentText:"",
            editedCommentText:"",
            requestedSequenceMetadata:{},
            selectedStatus:{label:"Open",type:"open"},
            statusList:[{label:"All",type:"all"},{label:"Open",type:"open"},{label:"Approved", type:"approved"},{label:"Rejected", type:"rejected"}],
            selectedRequestId:"",
            selectedCommentId:"",
            viewRequestedDetails:false,
            requestFileInfo:{},
            reRequestComponent:false,
            editRequestInfo:false,
            sCMList:[],
            enableOICBrowse:false,
            parentIPList:[],
            selectedAssetId:"",
            cEOMenu:false,
            eOMenu:false,
            selectedUserIdNameMapper:{},
            assetsPerpage:-1,
            options: { chunk: 5 },
            assetDetailsToShowPip:{},
            growingFileGif: Utils.getLoadingGif(),
            markForDeleteIcn: Utils.getMarkForDeleteIcon(),
            sharedData:[],
            assetInfo:[],
            openPip:false,
            selectedFiles:[],
            isActive:null,
            filterBy:{
                requestor_id : [],
            },
            timeBy:null,
            timeWith:null,
            searchKeyword:"",
            panelTypeApprover:false,
            showOtherFilesPreviewDialog:false,
            page: 1,
            totalPages: -1,
            totalAssets: -1,
            perPage: -1,
            selectedFileToViewVersions:null,
            openVersionDisplayDialog:false        }
    },
    mixins:[highlightMixin],
    components:{
        NewCommentComp:NewCommentComp,
        'cancel-icon':cancelIcon,
        "Multiselect":Multiselect,
        "users-multiselect":userMultiSelect,
        "DatePicker":DatePicker,
        "picture-in-picture":PictureInPicture,
        ImagePreviewDialog,
        "pagination":Pagination,
        "OCBrowse":OpenCatalogBrowse,
        "requested-metadatainfo":RequestedAssetMetadataInfo,
        "RerequestMetadata": RerequestMetadata,
        //"manage-version":ManageVersionsDialog loading from plugin
    },
    computed:{
        ...mapGetters("versions",["getVersionInfoDisplayCheck"]),
        ...mapGetters("users",["getLoggedInUserId"]),
        ...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserInfo"])
    },
    watch:{
        "$route.fullPath" : function(newVal, oldVal){
            if (newVal!=oldVal){
                this.handleMediaShareBrowse()
            }
        },
    },
    methods:{
        getCatalogCoverPhoto(catalog){
            if('catalog_cover_photo_path' in catalog){
                return this.getProxyConvertedURL(catalog.catalog_cover_photo_path);
            }
            return Utils.getNoThumbnailImg();
        },
        getSvgIconForCoverPhoto(type){
            return Utils.getSVGIconsBasedOnType(type)
        },
        openManageVersions(file){
            this.openVersionDisplayDialog = true;
            this.selectedFileToViewVersions = file;
        },
        closeVersionDisplayDialog(){
            this.openVersionDisplayDialog = false;
            this.selectedFileToViewVersions = null;
        },

        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        formatDateAndTime(date){
            return Utils.getDateAndTimeFormat(date);
        },
        getCommentTooltipD(commentInfo){
            return ["Commented by " + commentInfo.requestor_name + " ," +this.getDateAndTimeInConfiguredFormat(commentInfo.created_datetime, true),
                    " ",
                    commentInfo.comment].join("\n");
        },
        getStatusIcon(status){
            let statusIcon = `<svg data-v-29877e90="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" viewBox="0 0 16 16" class="bi bi-x-circle-fill">
                                <path data-v-29877e90="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z">
                                </path>
                                </svg>`;

            if(status == "open"){
                statusIcon = ""
                // statusIcon = `<svg data-v-976a8266="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" viewBox="0 0 16 16" class="bi bi-clock-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path></svg>`;
                
            }else if(status == "approved"){
                statusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" viewBox="0 0 16 16" class="bi bi-check-circle-fill"><path data-v-976a8266="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg>`;
            }

            return statusIcon;
        },
        heightSet(){
            // if(document.querySelector(".advanced-search-wrapper") != undefined){
                // let headerHeight = document.querySelector(".close-or-min-panel").getBoundingClientRect().height;
                // let commentHeight = document.querySelector(".comment_img_wrapper").getBoundingClientRect().height;
                let commentBodyheight = `calc(100% - 60px - 38px`;
                // let commentMainheight = `calc(100% - 60px -38px - ${commentHeight}px)`;
                let commentMainheight = `calc(100% - 60px -38px)`;
                this.resizedHeight  = commentMainheight;
                this.commnetresizedHeight = commentBodyheight;
            // }else{
            //   this.resizedHeight  = '100%';
            // }
        },
        customLabelPicklistSingleVal(option){
            return `${option}`
        },
        getRecieverName(usersInfo){
            let userNames =[]
            for(let op of usersInfo){
                userNames.push(op.username)
            }
            return userNames.join(", ");
        },
        getAllSharedFilesToolTip(files){
            let nameList = []
            for(let op of files){
                nameList.push(op.slug_name);
            }
            return nameList.join(", ");
        },
        getAssets(){
            return this.sharedData
        },
        isSharedToEntry(userIds, senderUserId){
            if(senderUserId == this.getLoggedInUserId){
                for(let op of this.filterBy['requestor_id']){
                    if(userIds.includes(op)){
                        return true;
                    }
                }
            }
            return false;
        },
        isActionEnable(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },
        detectLinkAndIds(item){
            let fileName = (item.slug_name + ',')
            return fileName.replace(fileName, function(b) {
                return '<a href="">' + b + '</a>';
            })
        },
        formatedDate(date){
            return Utils.getDateTimeFormat(date);
        },
        closeMinimisedPlayer(){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = false
        },
        showAssetDetailsDockCloseMiniplayer(){
            if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
            this.openPip = true;
        },
        showAssetDetailsDockCloseMaximisedplayer(){
            if(this.isFullscreenPreviewAllowed()){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = true;
                return;
            }
        },
        isFullscreenPreviewAllowed(){
            let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
            return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.assetDetailsToShowPip)) > -1
        },
        handleSharedToUsersList(user){
            if(!("requestor_id" in this.filterBy) ||
                ("requestor_id" in this.filterBy && !this.filterBy.requestor_id.includes(user._id))){
                this.filterBy["requestor_id"].push(user._id);
            }
            this.selectedUserIdNameMapper[user._id] = user.username
            this.handleFilters(false);
        },
        handleShareToRemovedUserFromList(user){
            if(this.filterBy.requestor_id.includes(user._id)){
                this.filterBy.requestor_id.splice(this.filterBy.requestor_id.indexOf(user._id), 1)
            }
            this.handleFilters(false);
        },
        onStatusChange(event){
            this.selectedStatus = event;
            this.handleFilters(false);
        },
        filterSharedAssetsByDate(dateRange){
            if(typeof dateRange != "undefined" &&
                dateRange != null && dateRange.length == 2 && dateRange[0] != null){
                let datefilter = {
                    from_value : dateRange[0],
                    to_value : dateRange[1]
                }
                this.filterBy["created_date"] = datefilter;
                this.timeBy = dateRange
            }else{
                if("created_date" in this.filterBy){
                    delete this.filterBy.created_date
                }
                this.timeBy = []
            }
            this.handleFilters(false)
        },
        getProfileImageOfUser(image){
            let defaultImage = Utils.getNoThumbnailImg()
            let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; style="width: 100%;border-radius: 6px;height: 100%;margin-bottom: 3px;">'
            return profileImageTag;
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        getThumbnailPath(file) {
            if([undefined,null].includes(file) || Object.keys(file).length <= 0){
                return Utils.getNoThumbnailImg();
            }
            return Utils.getThumbnailPathfromFileInfo(file);
        },
        getSvgIconsOfMediaTypes(path, type) {
            return Utils.determineSvgIconForType(path, type);
        },
        openPictureInPicture(fileInfo){
            this.assetDetailsToShowPip = fileInfo;
            if(this.isFullscreenPreviewAllowed()){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = true;
                return;
            }else{
                this.openPip = true;
                this.showOtherFilesPreviewDialog = false;
            }
        },
        setClipBoardText(file){
            let copiedLink = ""
            if(Object.keys(file).length && "access_url" in file){
                copiedLink = file.access_url;
            }
            if(copiedLink.trim().length <= 0){
                alert("Link is not avaialble.");
            }else{
                navigator.clipboard.writeText(copiedLink);
            }
            this.eOMenu = !this.eOMenu;
        },
        closeOCBrowser(){
            this.enableOICBrowse = false;
            this.eOMenu = !this.eOMenu
        },
        setRouterUrl(catalogId, catalogName, catalogType){
            this.closeOCBrowser();
            Utils.updateCookieByKeyName("context","catalogs-display");
            this.$router.push({
                name:"catalogs-display", 
                params:{
                    _id: catalogId, 
                    catalog_name: catalogName,
                    catalog_id: catalogId,
                    catalog_type: catalogType
                },
                query: {advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:this.selectedAssetId})}
            })
        },
        openAssetInCatalog(file){
            this.parentIPList = [];
            if("asset_id" in file && file.asset_id != undefined && file.asset_id.length > 0){
                this.selectedAssetId = file.asset_id;
                let payload = {params:{assetId: file.asset_id}}
                this.getAssetInfoFromServer(payload).then((data) => {
                    if (data.statusCode==200){
                        let selectedAssetDetails = data["asset"];
                        if("parent_id_path" in selectedAssetDetails &&
                            selectedAssetDetails.parent_id_path.length > 0){
                                this.parentIPList = selectedAssetDetails.parent_path;
                            if(selectedAssetDetails.parent_id_path.length == 1){
                                let pIPath = selectedAssetDetails.parent_id_path[0]
                                let cIdList = pIPath.split("/");
                                let catInfo = this.parentIPList[0];
                                this.setRouterUrl(cIdList[cIdList.length - 1],catInfo[catInfo.catalog_name], selectedAssetDetails.catalog_type)
                            }else{
                                this.enableOICBrowse = true;
                            }
                        }
                    }else{
                        if('message' in data){
                            this.$toast.error(data.message);
                        }
                        this.eOMenu = !this.eOMenu
                    }
                })
            }
        },
        showAssetDetails(fileInfo){
            if(!this.selectedFiles.includes(fileInfo.asset_id)){
                this.selectedFiles.push(fileInfo.asset_id);
            }
            this.isActive = fileInfo.asset_id;
            this.openPictureInPicture(fileInfo)
        },
        showAssetMetadataInfo(reqId){
            this.commentPage = 1;
            this.selectedRequestId = reqId;
            this.viewRequestedDetails = true;
        },
        handleShareAction(fileInfo){
            this.$emit("reshareAssetSignal",fileInfo);
        },
        handleDownloadAction(fileInfo){
            let payload = {};
            payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_path);
            payload.element_type = "file";
            payload.job_name = "Download";
            payload.file_name = fileInfo.file_name;
            payload.path = fileInfo.path;
            let fileName = fileInfo.file_name;
            this.initiateDownloadJob(payload).then((data) => {
                let jobIdFromResponse = data.job_id;
                let payload = { job_id: "job_id=" + jobIdFromResponse };
                let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
                const link = document.createElement("a");
                link.href = downnloadUrl;
                link.download = fileName;
                link.click(); 
                if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
                    console.log("Share asset Download initiated");
                } else if('message' in data) {
                    this.$toast.error(data.message);
                }
            });
        },
        isFileSelected(fileInfo){
            if (fileInfo.asset_id in this.selectedFiles){
                return true
            }
            return this.isActive == fileInfo.file_uid
        },
        getSharedFileNames(filesList){
            if(filesList == undefined){
                return ""
            }
            let fileNames = [];
            for(let op of filesList){
                fileNames.push(op.slug_name);
            }
            return fileNames.join(",")
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        isPrivilegeExists(privilegeName){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privilegeName);
        },
        functionCallForGlobalKeywordSearch(keyword){
            this.searchKeyword = keyword;
            this.handleFilters(false);
        },
        paginate(page) {
            this.page = page;
            this.handleFilters(true);
        },
        handleFilters(isPageClick = false){
            let payload = { params:{}};
            if(![undefined,null].includes(this.timeBy) && "created_date" in this.filterBy){
                payload.params["created_date"] = JSON.stringify(this.filterBy["created_date"])
            }
            if(this.panelTypeApprover && this.isActionEnable('tag-metadata-approver')){
                payload.params["type"] = 'Approve';
                if("requestor_id" in this.filterBy && this.filterBy.requestor_id.length > 0){
                    payload.params["requestor_id"] = JSON.stringify(this.filterBy.requestor_id);
                }
            }else{
                payload.params["type"] = "Requests";
            }
            if(![undefined, null].includes(this.searchKeyword) && this.searchKeyword.trim().length > 0){
                payload.params.keyword = this.searchKeyword
            }
            if(![undefined,null].includes(this.selectedStatus) && 'type' in this.selectedStatus &&
                this.selectedStatus.type.trim().length){
                payload.params["status"] = this.selectedStatus.type;
            }
            if(isPageClick){
                payload.params.page = this.page;
            }
            this.updateRouterQuery(payload.params);
        },
        fetchSharedAssets(routerParams = {}){
            let payload = { params:{}};
            if(![undefined, null].includes(routerParams) && Object.keys(routerParams).length > 0){
                payload.params = routerParams
            }
            if('status' in payload.params && payload.params.status == 'all'){
                delete payload.params['status']
            }
            this.sharedData = []
            if(this.panelTypeApprover && this.isActionEnable('tag-metadata-approver')){
                this.getAllRequestedMetadataAssetsFromServer(payload).then((data) => {
                    if (data.statusCode == 200){
                        this.sharedData = data.metadata_requests;
                        this.totalPages = data["page_count"];
                        this.page = data["page"];
                        this.totalAssets = data["total_requests"];
                        this.perPage = data["limit"];
                        this.assetsPerpage = data["requests_per_page"]
                        if(this.sharedData.length <= 0 && this.showComments){
                            this.showComments = false;
                        }
                    }else{
                        if(this.sharedData.length <= 0 && this.showComments){
                            this.showComments = false;
                        }
                    }
                });
            }else{
                this.getSessionUsersRequestedMetadataAssetsFromServer(payload).then((data) => {
                    if (data.statusCode == 200){
                        this.sharedData = data.metadata_requests;
                        this.totalPages = data["page_count"];
                        this.page = data["page"];
                        this.totalAssets = data["total_requests"];
                        this.perPage = data["limit"];
                        this.assetsPerpage = data["requests_per_page"]
                    }
                });
            }
        },
        getRouterName(){
            return "mr"
        },
        closeModal() {
            this.$router.go(-1) 
        },
        handleMediaShareBrowse(){
            let query=Object.assign({}, this.$route.query)
            let paramsBy = {
                    requestor_id : [],
                };
            if('requestor_id' in query){
                paramsBy["requestor_id"] = JSON.parse(query.requestor_id);
            }
            if('created_date' in query){
                paramsBy["created_date"] = JSON.parse(query.created_date);
                this.timeBy = [];
                this.timeBy.push(paramsBy["created_date"]["from_value"])
                this.timeBy.push(paramsBy["created_date"]["to_value"])
            }else{
                this.timeBy = []
            }
            if('keyword' in query){
                if(![undefined, null].includes(query.keyword) && query.keyword.trim().length > 0){
                    paramsBy["keyword"] = query.keyword;
                }
                this.searchKeyword = query.keyword;
                this.$emit("resetGloablSearchKeyWord", paramsBy["keyword"])
            }
            if('status' in query && query.status.trim().length > 0){
                paramsBy["status"] = query.status;
                let statusInfo = {type : query.status}
                if(paramsBy["status"] == "open"){
                    statusInfo["label"] = "Open"
                }else if(paramsBy["status"] == "rejected"){
                    statusInfo["label"] = "Rejected"
                }else if(paramsBy["status"] == "approved"){
                    statusInfo["label"] = "Approved"
                }else{
                    statusInfo["label"] = "All"
                }
                this.selectedStatus = statusInfo;
            }else{
                this.selectedStatus = {label:'Open',type:'open'}
            }
            if('type' in query){
                if(query.type == 'Approve' && this.isActionEnable('tag-metadata-approver')){
                    this.panelTypeApprover = true;
                }else{
                    this.panelTypeApprover = false;
                }
            }
            if('type' in query){
                delete query.type
            }
            this.filterBy = paramsBy;
            this.fetchSharedAssets(query)
        },
        updateRouterQuery(payloadParams){
            this.$router.push({
                query:payloadParams
            })
        },
        handleMetadataupdateRequestNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let reqInfo = notification.message;
            let mssgFrom = notification.message_from;
            if(notification.message){
                let mssg = ""
                if(notification.message_type == NotifierConstants.metadataRequestCreated){
                    if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                        if('requestor_name' in reqInfo){
                        mssg = reqInfo.requestor_name + " requested for metadata update.";
                        }else{
                            mssg = "New " + reqInfo.m_req_id + " metadata request is added.";
                        }
                        let mergeEntry = true;
                        if(this.selectedStatus.type != reqInfo.status && this.selectedStatus.type != 'all'){
                            mergeEntry = false;
                        }else if("requestor_id" in this.filterBy){
                            if(![undefined,null].includes(this.filterBy.requestor_id) && this.filterBy.requestor_id.length > 0 &&
                             !this.filterBy.requestor_id.includes(reqInfo.requestor_id)){
                                mergeEntry = false;
                            }
                        }else if(![undefined,null].includes(this.timeBy) && this.timeBy.length == 2){
                            let reqDate = Utils.getFollowedFormat(reqInfo.created_date, "YYYY-MM-DD");
                            if(this.timeBy[0] <= reqDate && this.timeBy[1] >= reqDate){
                                mergeEntry = false;
                            }
                        }else if(![undefined, null].includes(this.searchKeyword) && this.searchKeyword.trim().length > 0){
                            mergeEntry = false;
                        }
                        if(mergeEntry){
                            let existedList = this.sharedData.filter(op=>op._id == reqInfo._id);
                            if(existedList.length <= 0){
                                let existingData = this.sharedData
                                existingData.unshift(reqInfo)
                                this.sharedData = existingData;
                            }
                        }
                    }
                }else if(notification.message_type == NotifierConstants.metadataRequestUpdated){
                    mssg = reqInfo.m_req_id + " request updated.";
                    let findIndex = this.sharedData.findIndex(op=>op._id == reqInfo._id)
                    if(findIndex >= 0){
                        if(this.selectedStatus.type == reqInfo.status || this.selectedStatus.type == 'all'){
                            this.sharedData.splice(findIndex, 1, reqInfo)
                        }else{
                            this.sharedData = this.sharedData.filter(op=>op._id != reqInfo._id);
                        }
                    }
                }
                if(mssg.trim().length > 0 && mssgFrom.user_id != this.getLoggedInUserId){
                    this.$toast.info(mssg);
                }
            }
        },
        handleMRCommentNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let reqInfo = notification.message;
            let mssgFrom = notification.message_from;
            if(notification.message ){
                let mssg = "";
                if(notification.message_type == NotifierConstants.metadataReqCommentCreated){
                    if(this.selectedRequestId == reqInfo._id){
                        let mergeEntry = true
                            mssg = " New comment is added to " + reqInfo.m_req_id + ".";
                            if(mergeEntry){
                                let fIdx = this.sharedData.findIndex(op=>op._id == reqInfo._id);
                                if(fIdx >= 0){
                                    this.sharedData.splice(fIdx, 1, reqInfo)
                                    let existingData = this.commentsList
                                    existingData.push(reqInfo.comments[0])
                                    this.commentsList = existingData;
                                    setTimeout(()=>{
                                        this.$nextTick(() => {
                                            if(this.$refs.commentThreadWindow)this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                                        });
                                    }, 100);
                                }
                            }
                    }
                }else if(notification.message_type == NotifierConstants.metadataReqCommentUpdated){
                    if(this.selectedRequestId == reqInfo._id && this.showComments){
                            mssg = " Comment is updated in " + reqInfo.m_req_id + ".";
                    }
                    let fIdx = this.sharedData.findIndex(op=>op._id == reqInfo._id);
                    if(fIdx >= 0){
                        this.sharedData.splice(fIdx, 1, reqInfo)
                        let cmtIndx = this.commentsList.findIndex(op=>op._id == reqInfo.comments[0]._id);
                        if(cmtIndx >= 0){
                            this.commentsList.splice(cmtIndx, 1,reqInfo.comments[0])
                        }
                        setTimeout(()=>{
                            this.$nextTick(() => {
                                if(this.$refs.commentThreadWindow)this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                            });
                        }, 100);
                    }
                }else if(notification.message_type == NotifierConstants.metadataReqCommentDeleted){
                    if(this.selectedRequestId == reqInfo._id && this.showComments){
                            mssg = " Comment is deleted in " + reqInfo.m_req_id + ".";
                    }
                    let fIdx = this.commentsList.findIndex(op=>op._id == reqInfo._id);
                    if(fIdx >= 0){
                        let cmInfo = Object.assign({},this.commentsList[fIdx]);
                        cmInfo['status'] = 'Deleted';
                        this.commentsList.splice(fIdx, 1, cmInfo);
                        let fIdx = this.sharedData.findIndex(e=>("comments" in e &&
                                                                    ![undefined,null].includes(e.comments) &&
                                                                    e.comments.length > 0 &&
                                                                    e.comments[0]._id == reqInfo._id));
                        if(fIdx >= 0){
                            let cInfo = this.sharedData[fIdx];
                            cInfo.comments = [];
                            this.sharedData.splice(fIdx, 1, cInfo)
                        }
                    }
                }
                if(mssg.trim().length > 0 && mssgFrom.user_id != this.getLoggedInUserId){
                    this.$toast.info(mssg);
                }
            }
        },
        registertoWSListener(){
            this.addWSEventListener({
                eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
                NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
                NotifierConstants.tagRemovedNotification],
                callback:this.handleNotifications,
                parent:"MetadataRequestAssetDetails"})
            this.addWSEventListener({eventname:[NotifierConstants.metadataRequestCreated,NotifierConstants.metadataRequestUpdated],
             callback:this.handleMetadataupdateRequestNotification,parent:"MetadataRequestAssetDetails"})
            this.addWSEventListener({eventname:[NotifierConstants.metadataReqCommentCreated,NotifierConstants.metadataReqCommentUpdated,
            NotifierConstants.metadataReqCommentDeleted],
             callback:this.handleMRCommentNotification,parent:"MetadataRequestAssetDetails"})
        },
        unRegistertoWSListener(){
            this.removeWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
                    NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,NotifierConstants.tagModifiedNotification,
                    NotifierConstants.tagRemovedNotification],
                    callback:this.handleNotifications,
                    parent:"MetadataRequestAssetDetails"})
            this.addWSEventListener({eventname:[NotifierConstants.metadataRequestCreated,NotifierConstants.metadataRequestUpdated],
             callback:this.handleMetadataupdateRequestNotification,parent:"MetadataRequestAssetDetails"})
        },
        getFieldKeyName(kId){
            let cMList = this.sCMList.filter(op=>op._id == kId);
            if(cMList.length > 0){
                return cMList[0].name;
            }
            return "None"
        },
        getTagsNameList(tagsInfo){
            let nList = [];
            for(let op of tagsInfo){
                if(!nList.includes(op.name)){
                    nList.push(op.name)
                }
            }
            if(nList && nList.length > 0){
                return nList.join(", ");
            }else {
                return "None"
            }
        },
        getPiclistNameList(picklist){
            let nList = [];
            for(let op of picklist){
                if(!nList.includes(op.value)){
                    nList.push(op.value)
                }
            }
            if(nList && nList.length > 0){
                return nList.join(", ");
            }else {
                return "None"
            }
        },
        getCatalogsNameList(catalogsInfo){
            let nList = [];
            for(let op of catalogsInfo){
                let catNameList = op.catalog_name_path.split("/");
                if(catNameList.length > 1){
                    if(!nList.includes(catNameList[catNameList.length - 1])){
                        nList.push(catNameList[catNameList.length - 1])
                    }
                }
            }
            if(nList && nList.length > 0){
                return nList.join(", ");
            }else {
                return "None"
            }
        },
        handleNotifications(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
                      setTimeout(()=>{
                        this.refreshStartData("custom_metadatas");
                      }, 100);
            }else if([NotifierConstants.fieldModifiedNotification,
                    NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                      setTimeout(()=>{
                        this.refreshStartData("custom_metadatas");
                      }, 100);
            }
            // else if(NotifierConstants.catalogModifiedNotification == notification.message_type){
            //     if(this.selectedCatParentIdList.includes(notification.message._id)){
            //         this.$toast.info("Selected catalog is updated by another user");
            //         let catIndex = this.selectedCatParentIdPathList.findIndex(op=>op._id == notification.message._id)
            //         this.selectedCatParentIdPathList[catIndex] = notification.message;
            //     }
            // }else if(NotifierConstants.catalogRemovedCreatedNotification == notification.message_type){
            //         if(this.selectedCatParentIdList.includes(notification.message._id)){
            //         this.$toast.info("Selected catalog is deleted by another user");
            //         if(Utils.getCookieValue("context") == "catalogs-display"){
            //             this.getCategoryRoutefromId(this.getSelectedCategoryInCategoryBrowse,false);
            //         }else if(this.defaultCategory != undefined){
            //             this.getCategoryRoutefromId(this.defaultCategory,true);
            //         }else{
            //             let payload = {};
            //             payload.params = {catalog_id:JSON.stringify(Constants.rootCategory)}
            //             this.getAllAssetsFromServer(payload).then((data)=>{
            //             this.getCategoryRoutefromId(data["assets"][0],false)
            //             });
            //         }
            //         }
            // }else if(NotifierConstants.tagRemovedNotification == notification.message_type){
            //         let temp = this.tagNamesList.filter(e => e._id == notification.message._id)
            //         if (temp.length != 0){
            //         this.tagNamesList = this.tagNamesList.filter(e => e._id != notification.message._id)
            //         }
            // }
        },
        refreshStartData(keyName){
            if(keyName == "custom_metadatas" && Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
                this.sCMList = this.getStartUpDataFromInCache()["custom_metadatas"];
            }
        },
        switchToComment(){
            this.showComments = true;
            this.loadComments(false);
            if(this.cEOMenu){
                this.cEOMenu = !this.cEOMenu;
            }
            this.$refs.commentTextField.focus();
        },
        loadComments(isPageClick){
            if(!isPageClick){
                this.commentsList= [];
            }
            if([undefined,null].includes(this.selectedRequestId) || this.selectedRequestId.length <= 0){
                this.commentsList= [];
                return;
            }
            let payload = {params:{_id:this.selectedRequestId}};
            if(isPageClick){
                payload.params.page = this.commentPage;
            }
            if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                this.fetchApproverComments(payload).then((data) => {
                    if(Utils.isAcceptedStatusCode(data.statusCode)){
                        if('page_count' in data){
                            this.commentsPageCount = data.page_count;
                        }
                        if(isPageClick){
                            this.commentsList = this.commentsList.concat(data.comments)
                        }else{
                            this.commentsList = data.comments;
                            this.$nextTick(() => {
                                if(this.$refs.commentThreadWindow)this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                            });
                        }
                    }else if('message' in data){
                        this.$toast.error(data.message);
                    }
                })
            }else{
                this.fetchRequesterComments(payload).then((data) => {
                    if(Utils.isAcceptedStatusCode(data.statusCode)){
                        if('page_count' in data){
                            this.commentsPageCount = data.page_count;
                        }
                        if(isPageClick){
                            this.commentsList = this.commentsList.concat(data.comments)
                        }else{
                            this.commentsList = data.comments;
                            this.$nextTick(() => {
                                if(this.$refs.commentThreadWindow)this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                            });
                        }
                    }else if('message' in data){
                        this.$toast.error(data.message);
                    }
                })
            }
        },
        addComment(){
            if([undefined,null].includes(this.selectedRequestId) || this.selectedRequestId.trim().length <= 0){
                alert("Please select metadata request.");
                return;
            }
            if(this.commentText.trim().length > 0){
                    let payload = {params:{_id:this.selectedRequestId},comment:this.commentText}
                    if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                        this.addApproverComments(payload).then((data)=>{
                            if(Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                                this.commentText="";
                            }else if('message' in data){
                                this.$toast.error(data.message);
                            }
                        })
                    }else{
                        this.addRequestComments(payload).then((data)=>{
                            if(Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                                this.commentText="";
                            }else if('message' in data){
                                this.$toast.error(data.message);
                            }
                        })
                    }
                }
        },
        enableEditModeofComment(cId){
            this.selectedCommentId = cId;
                this.$nextTick(() => {
                    if(this.$refs.commentThreadWindow){
                        this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                    }
                });
        },
        cancelEditModeofSelectedComment(){
            this.selectedCommentId = "";
            this.editedCommentText = "";
                this.$nextTick(() => {
                    if(this.$refs.commentThreadWindow){
                        this.$refs.commentThreadWindow.scrollTop = this.$refs.commentThreadWindow.scrollHeight;
                    }
                });
        },
        editSelectedComment(cId){
            if([undefined,null].includes(this.selectedRequestId) || this.selectedRequestId.trim().length <= 0){
                alert("Please select metadata request.");
                return;
            }
            let payload = {status:"edited",comment:this.editedCommentText,params:{_id:this.selectedRequestId,comment_id:cId}}
                if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                    this.updateApproverComment(payload).then((data)=>{
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                            this.selectedCommentId = "";
                            this.editedCommentText = "";
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                        }else if('message' in data){
                            this.$toast.error(data.message);
                        }
                    })   
                }else{
                    this.updateRequesterComment(payload).then((data)=>{
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                            this.selectedCommentId = "";
                            this.editedCommentText = "";
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                        }else if('message' in data){
                            this.$toast.error(data.message);
                        }
                    })
                }
        },
        deleteSelectedCommnet(cId){
            if([undefined,null].includes(this.selectedRequestId) || this.selectedRequestId.trim().length <= 0){
                alert("Please select metadata request.");
                return;
            }
            let payload = {params:{_id:this.selectedRequestId,comment_id:cId}}
                if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                    this.deleteApproverComment(payload).then((data)=>{
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                        }else if('message' in data){
                            this.$toast.error(data.message);
                        }
                    })
                }else{
                    this.deleteRequestComment(payload).then((data)=>{
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                        }else if('message' in data){
                            this.$toast.error(data.message);
                        }
                    })
                }
        },
        reRequest(requestedMetadata, fileInfo, editRequest=false){
            this.requestFileInfo = fileInfo;
            let mDetails = {};
            let payload = {};
            let cmDetails = [];
            for(let op of requestedMetadata){
                if(['description'].includes(op.key_id)){
                    mDetails['description'] = op.value;
                }else if(['tag'].includes(op.key_id)){
                    mDetails['tag_ids'] = op.value
                    payload["tag_info"] = op.tag_info
                }else if(['slug_name'].includes(op.key_id)){
                    payload["slug_name"] = op.value;
                }else if(['catalog'].includes(op.key_id)){
                    payload["catalog_id_path"] = op.value
                    payload["catalog_info"] = op.catalog_info
                }else{
                    cmDetails.push({
                        key_id: op.key_id,
                        type: op.metadta_type,
                        value: op.value
                    })
                }
            }
            if(Object.keys(mDetails).length > 0){
                payload["metadata"] = mDetails
            }
            if(cmDetails.length > 0){
                payload["custom_metadata"] = cmDetails;
            }
            payload.request_id = this.selectedRequestId;
            this.requestedSequenceMetadata = payload;
            this.reRequestComponent = true;
            this.editRequestInfo = editRequest;
        },
        reject(){
            this.openCommentComponent = true;
        },
        rejectWithComments(commentText){
            this.updateRequestStatus("rejected")
            if(commentText.trim().length > 0){
                let payload = {params:{_id:this.selectedRequestId},comment:commentText}
                if(this.isActionEnable('tag-metadata-approver') && this.panelTypeApprover){
                    this.addApproverComments(payload).then((data)=>{
                        if(!Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                        }
                    })
                }else{
                    this.addRequestComments(payload).then((data)=>{
                        if(!Utils.isAcceptedStatusCode(data.statusCode)){
                            if('message' in data){
                                this.$toast.error(data.message);
                            }
                        }
                    })
                }
            }
            this.openCommentComponent = false;
        },
        updateRequestStatus(status){
            let payload = {params:{_id:this.selectedRequestId}};
            payload.status = status;
            this.updateMetadataRequestorAsset(payload).then((data) => {
                if(Utils.isAcceptedStatusCode(data.statusCode)){
                                if('message' in data){
                                    this.$toast.success(data.message);
                                }
                }else if('message' in data){
                    this.$toast.error(data.message);
                }
                //this.handleMediaShareBrowse();
            })
        },
        loadMoreComments(e){
            if (e.target.scrollTop == 0) {
                if(this.commentPage < this.commentsPageCount){
                    this.commentPage = this.commentPage + 1;
                    this.loadComments(true);
                }
            }
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
        ...mapActions("assets", ["getAssetInfoFromServer"]),
        ...mapActions("sharedAssets",["getSharedAssetsFromServer"]),
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapActions("metadataApprover", ["getAllRequestedMetadataAssetsFromServer","getSessionUsersRequestedMetadataAssetsFromServer","updateMetadataRequestorAsset",
                                            "fetchApproverComments","fetchRequesterComments",
                                            "addApproverComments", "addRequestComments",
                                            "deleteApproverComment","deleteRequestComment",
                                            "updateApproverComment", "updateRequesterComment"]),

    },
    beforeDestroy(){
        this.unRegistertoWSListener()
    },
    created(){
        try{ //load external plugin manage-versions. below code taken from index.js of then media version plugin
            Utils.loadPluginBundles([{id:'manage_version_bundle_js',jsUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.js`}],'mediaversion-component-loaded').then((event)=>{
                console.log("[Media version][Event]",event);
                if(event && Array.isArray(event) && event.length){
                    if(event[0].components['ManageVersionDialog']){
                    const ev = new Event('register-stores-routes');
                    if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                        ev.pluginStore = event[0].pluginStore;
                        parent.document.body.dispatchEvent(ev);
                        Utils.loadCssBundle({id:'manage_version_bundle_css',cssUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.css`});
                        this.$options.components['manage-version'] = event[0].components['ManageVersionDialog'];
                    }
                }
           });
        }catch(e){console.log(e)}
        // this.handleFilters(false);
        this.refreshStartData('custom_metadatas');
        this.registertoWSListener();
        this.handleMediaShareBrowse();
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
 $header-background: #1a1a1a;
    $border-color: 1px solid #3a3a3a;
    $background: #121212;
    $bg-color-on-hover: #141414;
    $body-bg-color: #0d0d0d;
   
    $sidebar-bg-color:#0e0e0e;
    $modal-bg-color:#141414;


    $header-background: #1a1a1a;
    $border-color: 1px solid #3a3a3a;
    $background: #121212;
    $background-color-on-hover: #141414;
    $body-background-color: #141414;
    $dull-text-color: #858585;
    $options-text-color: #9c9c9c;
    $icon-color-on-hover: #9c9c9c;
    $text-color: #eee;
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $input-field-bg-color: #121212;
    $input-field-border-color: #202020;
    $input-field-height:40px;
    $button-height:38px;
    // $secondary-border-color: 1px solid #3a3a3a;
    $secondary-border-color: 1px solid #2b2b2b;
    $secondary-background-color:#15181B;
    $searchBar-border-color: 1px solid #202020;
    $secondary-text-color: #bbb;
    $modal-border:1px solid #202020;
    $modal-background: #121212;
    $header-color:#9e9e9e;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#141414;
    $scrollbar-thumb-on-hover-background:#555;
    $input-field-padding:.375rem .75rem;
    $input-field-and-label-font-size:14px;
    $metadata-field-bg-color: #181818;
    $overlay-panel-border-color:#272727;
    $overlay-info-panel-bg-color:#1b1b1b;
    $panel-heading-font-size:20px;
    $wrapper-bg-color:#141414;


    $mutliselect-tag-bg-color:#131313;
    $mutliselect-all-tags-bg-color:#161616;
    $multiselect-option-highlight-bg-color:#333;
    $multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
    $multiselect-tag-border-color:#2e2e2e;
    
    $table-row-background-hover : #323232;


    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $tags-background-color:#212121;
    $tags-border-color:#2e2e2e;

    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $icon-hover:#2c3339;

    /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: #141414;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #333;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #555;
    }

    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: transparent;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 60px;
            }
            tr:hover{
                background: $table-row-background-hover !important;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

    .thumbnail-hw-set {
        height: 68px;
        width: 100%;
        border-radius: 93%;
        justify-content: center;
        display: flex;
        margin-inline-end: 10px;
        img {
            height: 100%;
            // width: 100%;
            border-radius: 7px;
        }
    }

    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: -1px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $body-bg-color;
    }

    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue;
        font-size: 16px;
        line-height: 1;
        transition: all 0.2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top: 2px;
    }
    
    .user-name-or-image-in-selected-option{
        border: 1px solid #3a3a3a;
        height: 27px;
        width: 27px;
        border-radius: 5px;
        text-align: center;
        line-height: 26px;
        text-transform: uppercase;
        margin-top: -1px;
        margin-inline-start: -1px;
    }
    .thumbnail-data {
        svg {
            border-radius: 5px;
            height: 100%;
            width: 100%;
        }
    }

    .reduce-opacity{
        opacity: 0.67
    }

    .svg-icons-display {
        height: 20px;
        width: 20px;
        position: relative;
        opacity: 0.8;
        inset-inline-end: 5px;
    }

    .file-name {
        white-space: nowrap;
        width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: initial;
        position: relative;
        inset-inline-start:2px;
        top: 2px;
    }

    .file-name-display-styles-in-list-view{
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // text-align: initial;
        width: 73%;
        text-align: start;
        padding: 8px 0px;
        display: inline-block;
        // .comm-review-title{
        //     // width: 100%;
        //     // display: inline-block;
        // }
        .comm-reivew-description{
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // text-align: initial;
            // width: 100%;
            // display: inline-block;
            color: #727272 !important;
            font-size: 13px !important;
            padding-top: 2px;
        }
    }
    .user-name-or-image-reciever{
        height: 30px;
        width: 30px;
        border: 1px solid #3a3a3a;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: -1px;
        margin-inline-end: -7px
    }
    .user-name-or-image{
        height: 30px;
        width: 30px;
        min-width:30px;
        border: 1px solid #3a3a3a;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }    

    .user-name{
        position: relative;
        bottom: 7px;
    }

    .activeclass{
        border:1px solid $active-blue !important;
        background: #22272b;
    }

    .user-name-align{
        text-align: start;
    }

    svg.svg-icon {
        width: 16px;
        height: 16px;
    }
    .comm-more-users-style{
        font-size: 12px!important;
        color: #000;
        height: 30px;
        width: 30px;
        border: 1px solid #3a3a3a;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        /* margin-top: 3px; */
        display: inline-block;
        background: #6c6c6c;
    }

     li {
      display: inline-block;
      //float:inline-start;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
  
    .config-value {
        margin-inline-start: 4px;
        width: auto;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    
    .show-delete-icon:hover{
        .parent-comment-delete{
            visibility: visible;
        }
    }

    .parent-comment-delete{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 5px 0px 5px 5px;
        visibility: hidden;
    }
    
    .parent-comment-options-wrapper, .reply-comment-options-wrapper{
        visibility: hidden;
        position: absolute;
        inset-inline-end: 7px;
        top: 4px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:2px;
        color: #999;
        background: #282828;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        border:1px solid #5a5a5a;
        button{
            height:30px;
            font-size:14px;
            svg{
                width: 20px;
                height: 20px;
                padding: 3px;
                // margin: 3px 0px 3px 3px;
                border: #fdfff4;
                border-radius: 4px;
            }
        }
    }

    .thumbnail-view-ul {
        list-style-type: none;
        display: block;
        flex-wrap: wrap;
        padding: 0px;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        width: 100%;
        justify-content: start;
        overflow: auto;
        border-bottom:  $secondary-border-color;
        // position:relative; 
        li{
            display:inline-block;
            width: 100%;
            position: relative;
            padding:10px 10px 10px 0px;
            .asset-thumbnail {
                display: inline-block;
                margin-inline-end: 10px;
                width: 174px;
                padding-inline-start: 5px;
                //margin-top: 5px;
                height: 128px;
                .thumbnail-view1 {
                    height: 93px;
                    width: 160px;
                    border-radius: 7px;
                    //margin-top: 8px;
                    position:relative;
                }
                .thumbnail-view {
                height: 93px;
                width: 160px;
                border-radius: 7px;
                //margin-top: 8px;
                border: $border-color;
                position:relative;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 7px;
                    object-fit: contain;
                }
                }
                .thumbnail-data {
                text-align: center !important;
                }
            }
        }
    }
    .thumbnail-view-ul li:hover{
        background: #22272b;
        .parent-comment-options-wrapper{
            visibility: visible;
        }
    }
    .parent-comment-options-wrapper button:hover{
        fill: #fdfff4;
    }
     ::v-deep {

        .mx-input{
            background-color:#1a1e21 !important;
            border: none !important;
            color: #eee !important;
            height:100%;
            &::placeholder {
                color: #adadad !important;
            }
        }
        .mx-input-wrapper{
        width:100%;
        height:100%;
        }
        .mx-datepicker-main{
            border: 1px solid #2f2f2f !important;
            background: $background !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: #505050 !important;
        }
        .mx-datepicker-range{
        width:100%;
        height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            border:1px solid #5a5a5a!important;
            height: 27px !important;
        }

        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }

        .page-item.disabled .page-link {
            background-color: #0d0d0d !important;
            border: 1px solid #333 !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: #0d0d0d !important;
            // border: none !important;
            border: 1px solid #333 !important;
            color:$active-blue;
        }
        .page-link {
            background-color: #0d0d0d !important;
            border: 1px solid #333 !important;
            // border: none !important;
            color:$text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: #1a1a1a !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: #797979 !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: 1px solid #242424 !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
        .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__tags-wrap{
        display:block;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $mutliselect-tag-bg-color !important;
        border: 1px solid $multiselect-tag-border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: #1a1e21 !important;
        border: 1px solid $filter-border-color !important;
    }
        .multiselect__option--highlight {
            background: $multiselect-option-highlight-bg-color !important;
        }
        .multiselect__content {
            background: $header-background !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $multiselect-tag-on-focus-or-hover-bg-color !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$icon-color-on-hover !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 6px 40px 0 8px;
        }
        .multiselect__placeholder {
            // padding-top: 5px !important;
            margin-bottom:0px;
            color:#adadad !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 36px;
        }
        .multiselect__single{
            padding-top:3px !important;
        }
        .multiselect__option--selected{
            background: $multiselect-option-highlight-bg-color !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $multiselect-option-highlight-bg-color !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $header-background !important;
        }
        .multiselect__tags {
            height: auto;
        }
        // .name-count-parent-wrap{
        //     background: transparent !important;
        //     border: none !important;
        //     display: inline-flex;
        //     margin-inline-start: 7px;
        //     background: #161616 !important;
        //     border: 1px solid #202020 !important;
        // }

    }
    [v-cloak] .hide-element-util-mount{ //sometimes un-necessary preview dialog was showing to hide code is required
    display: none;
    }
    .hide{
        display:none;
    }
    .dull-text-display{
        color:$dull-text-color;
    }
    .file-link:hover{
        text-decoration-line: underline
    }
    .key-ellipsis-to-entry{
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        // inset-inline-start:2px;
        overflow: hidden;
        display: block;
    }

    .value-ellipsis-to-entry{
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        inset-inline-start:2px;
        overflow: hidden;
        color: #dde4e4;
        margin-inline-start: 3px;
    }
    .comment-ellipsis-to-entry{
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }
    .latest-comment:hover{
        border:1px solid rgb(68, 68, 68);
    }
        
    .storage-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .thumbnail-view:hover, .thumbnail-view1:hover{
        .storage-type-icons-wrapper{
            visibility: visible;
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        font-size: 14px !important;
        border: 1px solid #757575;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding: 3px !important;
      }
    }
    .comment-overflow-parent-div {
      .overflow-menu{
        font-size: 14px!important;
        border: 1px solid #757575;
        top: 43px;
        display: inline-block;
        padding: 3px!important;
        width: 145px;
        max-width: 145px !important;
      }
    }
    .storage-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .storage-type-icons-wrapper .action-div:hover, .parent-comment-options-wrapper .action-div:hover{
        color: #fdfff4;
        background: #141414 !important;
    }
    .storage-type-icons-wrapper .action-div{
        color: #a3adad;
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .parent-comment-options-wrapper .action-div{
        color: #a3adad;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-inline-start: 4px;
        height: 35px;
        font-weight: 400;
        font-size: 1rem;
    }
    .breadcrumb{
        padding: .75rem 1rem !important;
        .active-text-nav-bar{
            color: $text-color !important;
            text-decoration: none !important
        }
        .active-text-nav-bar:last-child{
                color: $active-blue !important;
                font-size:17px;
        }
        .breadcrumb-item{
            a{
                color: $text-color;
                font-size: 24px !important;
            }
            a:hover{
                text-decoration: underline;
            }
        }
    }
    
    .nav-item{
        background: #1a1a1a !important;
        color: #626767 !important;
    }

    .active{
        background: $body-background-color !important;
        color:#eee !important;
    }
    
    .tags-display-ul{
        text-align:start;
    }
    
    .view-tags {
        font-size:12px!important;
        height: 30px!important;
        display: inline-flex!important;
        margin: 2px!important;
        border: 1px solid $tags-border-color!important;
        border-radius: 15px!important;
        min-width: 50px!important;
        padding: 0!important;
        text-align: center;
        width: auto!important;
        padding-inline-start: 1px!important;
        justify-content: center;
        padding-top: 4px!important;
        background: $tags-background-color;
        span {
            padding: 0px 8px !important;
            margin-inline-start: 0px !important;
            font-size:12px !important;
            border-radius: 15px !important;
            position: relative !important;
            top: 1px !important;
        }
    }
    .comments-dock{
        list-style-type: none;
        padding:0px;
        position: absolute;
        bottom:10%;
        inset-inline-end:0px;
        li{
            height:30px;
            width:30px;
            border: 1px solid #848484;
            border-top-left-radius: 9px;
            border-bottom-left-radius: 9px;
            padding: 0px;
            border-inline-end: none !important;
            svg{
                margin-top: 3px;
                color:#eee;
            }
        }
    }
    .close-or-min-panel{
        height: 38px;
        width:100%;
        border-bottom: 1px solid $overlay-panel-border-color;
        background: $overlay-info-panel-bg-color;
        padding-inline-start: 6px;
        display: flex;
        // justify-content: flex-end;
        svg{
            margin-inline-end:0px !important;
            top:-3px;
        }
    }

    .comments-section{
        height:calc(100% - 38px);
        // overflow: auto;
        display: inline-block;
        width: 100%;
        .added-comments-wrapper{
            // max-height:calc(100% - 150px);
            // max-height:100%;
            overflow: auto;
        }
    }

    .comm-comment-wrapper{
        border-bottom: $secondary-border-color;
        padding: 8px 5px;
        position:relative !important;
    }
    .comm-comment-wrapper:hover{
        background: $bg-color-on-hover;
        .actions-on-messages{
            visibility: visible;
        }
    }
    .heading{
        text-align:start;
        width:80%;
        padding: 3px;
        font-size:$panel-heading-font-size;
        color:$text-color;
    }.modal-footer{
    border-top: $secondary-border-color !important;
    // border-bottom: $secondary-border-color !important;
    // background: $secondary-background-color;
    height: 50px;
    .modal-title{
      color:$text-color;
    }
}

.common-input-field{
    margin-inline-start: 2%;
    margin-top:5px;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px 9px 0px 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    $secondary-border-color: 1px solid #2b2b2b;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

    .comm-tag-title-hover:hover{
        text-decoration: underline;
    }
.default-buttons:hover{
    color: #fdfff4;
}

.metadata-key-styles{
    color: #757575;
    width: 127px;
    text-align: end;
    float:inline-start;
}

.metadata-value-styles{
    color: #b6b6b6;
    max-width: 70%;
    text-align: start;
    // margin-inline-start: 11px;
    display: inline-block;
}

.actions-on-messages{
    position: absolute;
    inset-inline-end: 0px;
    border: $secondary-border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    top: -1px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-messages{
    visibility: hidden;
}
    .breadcrumb{
        padding: .75rem 1rem !important;
        .active-text-nav-bar{
            color: $text-color !important;
            text-decoration: none !important
        }
        .active-text-nav-bar:last-child{
                color: $active-blue !important;
                font-size:17px;
        }
        .breadcrumb-item{
            a{
                color: $text-color;
                font-size: 24px !important;
            }
            a:hover{
                text-decoration: underline;
            }
        }
    }
    
    .nav-item{
        background: $primary-background !important;
        color: #757575 !important;
    }

    .active{
        color:$text-color !important;
    }
    .status-as-tag{
        margin: 5px;
        border: 1px solid #EEEEEE;
        padding: 3px;
        border-radius: 8px;
        font-size: 11px;
        height: 23px;
        width: max-content;
        color: #EEEEEE;
        text-transform: capitalize;
    }
    .status-approved{
        color: #57af57;
        border: 1px solid #57af57;
    }
    .status-rejected{
        color: #cc6464;
        border: 1px solid #cc6464;
    }

    .outdated-text{
        position: absolute;
        top: 0px;
        font-weight: 500;
        background: #cf7f06;
        z-index: 0;
        width: 79px;
        text-align: center!important;
        height: 26px;
        padding-top: 3px;
        inset-inline-start:0px;
        font-size: 13px;
        border-radius: 5px;
    }
    
</style>